export default {"src":"/_next/static/media/email.5b874092.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};